import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {faChevronRight, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import {MatIcon} from "@angular/material/icon";
import { NgClass } from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {BreadcrumbComponent, BreadcrumbNavigation} from "../../../shared/ui/breadcrumb/breadcrumb.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SearchBarComponent} from "../../../shared/ui/search-bar/search-bar.component";

interface Guide {
  name: string
  src: SafeResourceUrl
}
@Component({
    selector: 'guide-list',
    imports: [
    MatIcon,
    NgClass,
    FaIconComponent,
    BreadcrumbComponent,
    ReactiveFormsModule,
    FormsModule,
    SearchBarComponent
],
    templateUrl: './guide-list.component.html',
    styleUrls: ['../userManagement/userRoleAddEdit/userRoleAddEdit.css']
})
export class GuideListComponent implements OnInit{
  sanitizer = inject(DomSanitizer)
  router = inject(Router)
  route = inject(ActivatedRoute)
  guideIsOpened = false
  selectedGuide: Guide = {
    name: '',
    src: ''
  }
  guides: Guide[] = [
    {
      name: 'Creating and Assigning a Sample Math Exam',
      src: 'https://scribehow.com/embed/Creating_and_Assigning_a_Sample_Math_Exam__TAUYrdswQsSGuwoirDCF6Q?as=scrollable'
    },
    {
      name: 'How to delete an exam',
      src: 'https://scribehow.com/embed/How_to_Delete_an_Exam__HNcVfJSGRsCU-RpnIu2xzA?as=scrollable'
    },
    {
      name: 'How to Create an Exam Report',
      src: 'https://scribehow.com/embed/How_to_Create_an_Exam_Report__phEqUvHLTX6ON09amO3Fmg?as=scrollable'
    },
    {
      name: 'How to Export an Exam Report',
      src: 'https://scribehow.com/embed/How_to_Export_an_Exam_Report__r8NajpluTC-2mBQAv0_eog?as=scrollable'
    },
    {
      name: 'How to Assign and Remove Graders to an Exam',
      src: 'https://scribehow.com/embed/How_to_Assign_and_Remove_Graders_to_an_Exam__9Lf6zAL-SPmiLXn3MXHl8w?as=scrollable'
    },
    {
      name: 'How to Assign a New Owner to an Exam',
      src: 'https://scribehow.com/embed/How_to_Assign_a_New_Owner_to_an_Exam__ED-iEPqfQH6RVV1R1LJnJg?as=scrollable'
    },
    {
      name: 'How to Set an Exam to Ready, Active, or Close State',
      src: 'https://scribehow.com/embed/How_to_Set_an_Exam_to_Ready_Active_or_Close_State__k055uNRBSXKEpYEjowoGQg?as=scrollable'
    },
    {
      name: 'How to Review an Exam Submission',
      src: 'https://scribehow.com/embed/How_to_Review_an_Exam_Submission__FYnn7n7XQQugx-oF5QXsFg?as=scrollable'
    },
    {
      name: 'How to Clone an Exam',
      src: 'https://scribehow.com/embed/How_to_Clone_an_Exam__3_BJz6EhSNSDvzC7AF8Dwg?as=scrollable'
    },
    {
      name: 'How to Edit your Exam',
      src: 'https://scribehow.com/embed/How_to_Edit_your_Exam__PzMvmiJiTiSlhfRlDUaHCg?as=scrollable'
    },
    {
      name: 'How to Preview Exam Problems',
      src: 'https://scribehow.com/embed/How_to_Preview_Exam_Problems__J3Z3soUkT-WpCsTQO00JfA?as=scrollable'
    },
    {
      name: 'How to Change Due Date for a Student',
      src: 'https://scribehow.com/embed/How_to_Change_Due_Date_for_a_Student__dOri2T-MTze6dVvQ1LMDcA?as=scrollable'
    },
    {
      name: 'How to Assign a New Attempt for a Student',
      src: 'https://scribehow.com/embed/How_to_Assign_a_New_Attempt_for_a_Student__kePTSCV2Tg6iqSMiyllTWQ?as=scrollable'
    },
    {
      name: 'How to Reset an Entire Exam or Exam Part for a Student',
      src: 'https://scribehow.com/embed/How_to_Reset_an_Entire_Exam_or_Exam_Part_for_a_Student__MMMqfJ5GTVOYdsAqHTqzEg?as=scrollable'
    },
    {
      name: 'How to Add or Remove an Editor on an Exam',
      src: 'https://scribehow.com/embed/How_to_Add_or_Remove_an_Editor_on_an_Exam__MqfgO6ABSI-EQU8do1eASQ?as=scrollable'
    },
    {
      name: "How to Add and View Graders' Comments on an Exam",
      src: 'https://scribehow.com/embed/How_to_Add_and_View_Graders_Comments_on_an_Exam__E4T46_CXT3KOYp_7q4jKjQ?as=scrollable'
    },
    {
      name: 'How to Increase Exam Time for a Student',
      src: 'https://scribehow.com/embed/How_to_Increase_Exam_Time_for_a_Student__b1huX87ES_Wbk9-V9_tNwQ?as=scrollable'
    }
  ]

  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'Guides',
    route: 'dashboard/Guides'
  }]
  searchIconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; margin-left: 0.5rem; flex-shrink: 1;`
  searchText = ""

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if(params['src'] && params['name']) {
        this.guideIsOpened = true
        this.selectedGuide = {
          name: params['name'],
          src: params['src']
        }
      } else {
        this.guideIsOpened = false
      }
    })
  }

  openGuide(src: SafeResourceUrl, name: string){
    this.router.navigate([], {queryParams: {src: src, name: name}})
    this.guideIsOpened = true
    this.selectedGuide = {
      name: name,
      src: src
    }
  }

  transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  navigateBack() {
    this.router.navigate([], {queryParams: {src: null, name: null}})
    this.guideIsOpened = false
    this.selectedGuide = {
      name: '',
      src: ''
    }
  }

  protected readonly faChevronRight = faChevronRight;
  protected readonly faMagnifyingGlass = faMagnifyingGlass;
}
